import {useCallback} from 'react';
import {useSyncExternalStore} from 'use-sync-external-store/shim';

import {TFIFileMetaState} from 'notebook/tfi/TFIConstants';
import TFIStore from 'notebook/tfi/TFIStore';

/**
 * Subscribes to the TFIStore and returns the sync state (upstream revision, whether an update check is in
 * flight) for the given TFIFileMeta, or null when there is no TFIFileMeta.
 */
export default function useTFIFileMetaState(
  tfiFileMetaId: number | null | undefined
): TFIFileMetaState | null {
  const subscribe = useCallback((onStoreChange: () => void) => {
    TFIStore.addChangeListener(onStoreChange);
    return () => {
      TFIStore.removeChangeListener(onStoreChange);
    };
  }, []);
  const getSnapshot = useCallback(
    () => (tfiFileMetaId != null ? (TFIStore.getTFIFileMetaState(String(tfiFileMetaId)) ?? null) : null),
    [tfiFileMetaId]
  );
  return useSyncExternalStore(subscribe, getSnapshot);
}
